import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Button } from 'react-bootstrap'

/**
 * @param {{
 *    block?: boolean
 *    className?: string
 *    color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'light' | 'dark'
 *    disabled?: boolean
 *    id?: string
 *    onClick?: any
 *    outline?: boolean
 *    tiny?: boolean
 *    type?: string
 * }} props
 * @returns {React.Component}
 */
const ZariButton = ({ className, outline, tiny, ...props }) => {
  const variant = React.useMemo(() => {
    const outlineValue = outline ? 'outline-' : ''
    return `${outlineValue}${props.color}`
  }, [props.color, outline])

  return (
    <Button
      {...props}
      className={clsx(
        'zr-button',
        {
          'zr-button-tiny': tiny
        },
        className
      )}
      variant={variant}
      size='sm'
    />
  )
}

ZariButton.propTypes = {
  block: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'warning',
    'danger',
    'info',
    'light',
    'dark'
  ]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
  tiny: PropTypes.bool,
  type: PropTypes.string
}

ZariButton.defaultProps = {
  color: 'primary',
  type: 'button'
}

export default ZariButton
